export var FlipType;

(function (FlipType) {
  FlipType["Vertical"] = "vertical";
  FlipType["Horizontal"] = "horizontal";
})(FlipType || (FlipType = {}));

export var SaveFormat;

(function (SaveFormat) {
  SaveFormat["JPEG"] = "jpeg";
  SaveFormat["PNG"] = "png";
  SaveFormat["WEBP"] = "webp";
})(SaveFormat || (SaveFormat = {}));